module.exports = __webpack_public_path__ + "static/media/FanSaves-How-To-Explainer.0d31ed9c.mp4";